import type {BioIconProps} from '../common-types'

export function BackArrowIcon({fill = '#1C1B1F', ...attributes}: BioIconProps) {
  return (
    <svg width="10" height="18" viewBox="0 0 10 18" fill="none" xmlns="http://www.w3.org/2000/svg" {...attributes}>
      <path
        d="M8.47786 0.666645L9.95703 2.14581L3.10286 8.99998L9.95703 15.8541L8.47786 17.3333L0.144531 8.99998L8.47786 0.666645Z"
        fill={fill}
      />
    </svg>
  )
}
